import { render } from "./discuss_stock.vue?vue&type=template&id=1bc313f8"
import script from "./discuss_stock.vue?vue&type=script&lang=js"
export * from "./discuss_stock.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__